/**
 * Attachment field names used as fieldName group in presigned client.
 */
export const ATTACHMENT_FIELD_NAMES = [
  "student_id_attachments",
  "visa_attachments",
  "polish_card_attachments",
  "residence_card_attachments",
  "employment_certificate_attachments",
  "attachments",
] as const;

export type AttachmentFieldName = (typeof ATTACHMENT_FIELD_NAMES)[number];

export interface QuestionnaireAttachmentMeta {
  id: string | null;
  filename: string;
  s3Key: string;
  size?: string;
  confirmed_at?: string | null;
  canDelete: boolean;
}

export interface AttachmentFormValue {
  id?: string;
  filename: string;
  s3_key: string;
}

/**
 * Complete attachment item with form data, metadata, and computed values for UI rendering.
 */
export interface AttachmentItem {
  index: number;
  key: string;
  field: AttachmentFormValue;
  meta?: QuestionnaireAttachmentMeta;
  url: string | null;
}

export interface PendingDelete {
  attachmentId: string;
  index: number;
  filename: string;
  s3Key: string;
}
